import qs from 'query-string';
import { baseUrl } from '../../config.js';

// Return the route to navigate to after login or account creation
export default function getLoginRedirect(): string {
  const query = qs.parse(window.location.search);
  if (query.returnToCli === 'true') {
    return '/login-cli-complete';
  }

  if (query.then && typeof query.then === 'string') {
    const url = new URL(`${baseUrl}${query.then}`);
    // Protect against open redirection vulnerability. Checking the origin prevents
    // a redirect like '.evil.org' generating a url like 'https://takeshape.io.evil.org'.
    if (url.origin === baseUrl) {
      return url.toString();
    }
  }

  return '/projects';
}
